import extractBrochureLayoutData from './extractBrochureLayoutData';

const extractBrochurePaperData = (
  brochure,
  roomDescriptions,
  hotelDetailsStore = {},
  rateDisplayPreference,
) => {
  const baseDoc = extractBrochureLayoutData(brochure, roomDescriptions, hotelDetailsStore, {
    doShowBookButton: false,
    rateDisplayPreference,
  });
  const content = baseDoc?.content || [];

  const { createdFor, fromEmail, emailRecipients, emailMessage } = brochure || {};

  const metaNodes = [];
  if (createdFor) {
    metaNodes.push({
      type: 'heading',
      attrs: {
        textAlign: 'left',
        level: 2,
        class: 'tt2-section-heading',
      },
      content: [{ type: 'text', text: `Proposal for ${createdFor}` }],
    });
  }
  if (fromEmail) {
    metaNodes.push({
      type: 'paragraph',
      attrs: { textAlign: 'left', class: 'tt3-meta' },
      content: [{ type: 'text', text: `Prepared by ${fromEmail}` }],
    });
  }
  if (emailRecipients && emailRecipients.length) {
    metaNodes.push({
      type: 'paragraph',
      attrs: { textAlign: 'left', class: 'tt3-meta' },
      content: [{ type: 'text', text: `Guests: ${emailRecipients.join(', ')}` }],
    });
  }
  if (emailMessage) {
    metaNodes.push({
      type: 'paragraph',
      attrs: { textAlign: 'left', class: 'tt3-message' },
      content: [{ type: 'text', text: emailMessage }],
    });
  }

  if (!metaNodes.length) return baseDoc || { type: 'doc', content: [] };

  return {
    type: 'doc',
    content: [...metaNodes, ...content],
  };
};

export default extractBrochurePaperData;
